import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=516c0b55&scoped=true&"
import script from "./Home1.vue?vue&type=script&lang=js&"
export * from "./Home1.vue?vue&type=script&lang=js&"
import style0 from "./Home1.vue?vue&type=style&index=0&id=516c0b55&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c0b55",
  null
  
)

export default component.exports